import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-176">
      <button className="flex w-full items-center justify-between py-5 text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-177">
        <span className="text-lg font-semibold text-gray-900 pr-8" data-id="element-178">
          {question}
        </span>
        {isOpen ? <ChevronUp className="h-6 w-6 text-blue-900 flex-shrink-0" data-id="element-179" /> : <ChevronDown className="h-6 w-6 text-gray-400 flex-shrink-0" data-id="element-180" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-5' : 'max-h-0 opacity-0'}`} data-id="element-181">
        <p className="text-gray-600 leading-relaxed" data-id="element-182">{answer}</p>
      </div>
    </div>;
}